import { render } from "./node.vue?vue&type=template&id=5cc38c18&scoped=true"
import script from "./node.vue?vue&type=script&lang=js"
export * from "./node.vue?vue&type=script&lang=js"

import "./node.vue?vue&type=style&index=0&id=5cc38c18&lang=scss&scoped=true"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc38c18"]])

export default __exports__